var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect, _path85;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopUpHpr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2801 1.09809C57.347 5.67114 67.4748 23.2135 62.9021 40.28C58.3286 57.3468 40.7859 67.4746 23.7194 62.9016C6.65296 58.3282 -3.4752 40.7861 1.09821 23.7197C5.67091 6.65283 23.2133 -3.47497 40.2801 1.09809Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2853 48.6263C40.095 48.6263 47.2366 41.4846 47.2366 32.675C47.2366 23.8653 40.095 16.7236 31.2853 16.7236C22.4756 16.7236 15.334 23.8653 15.334 32.675C15.334 41.4846 22.4756 48.6263 31.2853 48.6263Z",
    fill: "#E57E03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5816 45.3611L21.5999 45.3428C21.5327 45.2939 21.4654 45.2389 21.4043 45.1899L21.5816 45.3611Z",
    fill: "#BF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.471 46.5841L23.4648 46.578C23.4159 46.5536 23.367 46.523 23.3242 46.4985L23.4893 46.6514L23.526 46.6086C23.5015 46.6025 23.4893 46.5902 23.471 46.5841Z",
    fill: "#BF5F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4709 46.5842C23.4709 46.5781 23.4648 46.5781 23.4648 46.5781L23.4709 46.5842Z",
    fill: "#FFF35A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9376 43.7217L19.583 43.3854L25.0733 37.5894L25.2996 37.8033L25.324 37.7728L25.4157 37.8584L25.3913 37.8889L25.428 37.9256L19.9376 43.7217Z",
    fill: "#FFF35A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0351 39.5291L21.5692 45.2945L21.4775 45.2089L26.9434 39.4435L26.7172 39.2295L21.2207 45.0255L21.398 45.1906C21.4653 45.2395 21.5264 45.2945 21.5937 45.3435L27.0718 39.5658L27.0351 39.5291Z",
    fill: "#BF5F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9315 43.6559L19.8398 43.5764L25.3057 37.8048L25.0795 37.5908L19.583 43.3869L19.9376 43.7231L25.4341 37.9271L25.3913 37.8904L19.9315 43.6559Z",
    fill: "#BF5F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6675 36.1656L23.4413 35.9517L18.0732 41.6132C18.1344 41.6988 18.1955 41.7905 18.2567 41.8761L23.6675 36.1656Z",
    fill: "#BF5F00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7524 36.252L18.3232 41.9807C18.3355 41.993 18.3416 42.0113 18.3538 42.0235L23.7891 36.2886L23.7524 36.252Z",
    fill: "#FFF35A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0222 34.5265L21.796 34.3125L16.8682 39.5155C16.9171 39.6194 16.966 39.7172 17.0149 39.8151L22.0222 34.5265Z",
    fill: "#BF5F00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1141 34.6123L17.0762 39.9315C17.0823 39.9498 17.0945 39.962 17.1006 39.9804L22.1508 34.649L22.1141 34.6123Z",
    fill: "#FFF35A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 32.9688L16.1035 37.5787C16.1096 37.597 16.1157 37.6154 16.1219 37.6337L20.5117 32.9993L20.475 32.9688Z",
    fill: "#FFF35A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3835 32.8893L20.1573 32.6753L15.957 37.1079C15.9876 37.2241 16.0243 37.3403 16.061 37.4564L20.3835 32.8893Z",
    fill: "#BF5F00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7449 31.2433L18.5187 31.0293L15.4189 34.3003C15.4312 34.4348 15.4495 34.5754 15.4679 34.7099L18.7449 31.2433Z",
    fill: "#BF5F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8368 31.3296L15.4863 34.8635C15.4863 34.8879 15.4924 34.9063 15.4986 34.9307L18.8796 31.3663L18.8368 31.3296Z",
    fill: "#FFF35A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1069 29.6046L16.8807 29.3906L15.4317 30.9191C15.4134 31.0903 15.395 31.2554 15.3828 31.4266L17.1069 29.6046Z",
    fill: "#BF5F00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1923 29.6924L15.3704 31.6183C15.3704 31.6427 15.3643 31.6733 15.3643 31.6978L17.2351 29.7291L17.1923 29.6924Z",
    fill: "#FFF35A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8428 23.5771L15.8233 28.7373C15.8172 28.774 15.8049 28.8046 15.7988 28.8413L20.8795 23.6138L20.8428 23.5771Z",
    fill: "#FFF35A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7573 23.4911L20.5311 23.271L16.0802 27.8504C16.0129 28.0643 15.9518 28.2783 15.8906 28.4923L20.7573 23.4911Z",
    fill: "#BF5F00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7568 21.4193L20.5306 21.1992L18.0911 23.7059C17.8221 24.1034 17.5715 24.513 17.333 24.9348L20.7568 21.4193Z",
    fill: "#BF5F00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8422 21.5059L17.1188 25.3332C17.0882 25.3882 17.0638 25.4433 17.0332 25.4922L20.8728 21.5425L20.8422 21.5059Z",
    fill: "#FFF35A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9366 40.8184L23.4707 46.5838C23.489 46.5899 23.5013 46.6022 23.5196 46.6083L28.9733 40.8489L28.9366 40.8184Z",
    fill: "#FFF35A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3796 46.498L28.8455 40.7325L28.6192 40.5186L23.1289 46.3146L23.3246 46.498C23.3735 46.5225 23.4224 46.553 23.4652 46.5775L23.3796 46.498Z",
    fill: "#BF5F00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8377 42.103L25.6348 47.5934C25.6531 47.5995 25.6714 47.6056 25.6898 47.6117L30.8744 42.1397L30.8377 42.103Z",
    fill: "#FFF35A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7468 42.0167L30.5206 41.8027L25.1953 47.4215C25.2992 47.4643 25.4032 47.5071 25.5071 47.5499L30.7468 42.0167Z",
    fill: "#BF5F00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6483 43.3058L32.4221 43.0918L27.5859 48.197C27.7021 48.2275 27.8244 48.252 27.9405 48.2764L32.6483 43.3058Z",
    fill: "#BF5F00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7406 43.3857L28.0879 48.3014C28.1062 48.3075 28.1307 48.3075 28.149 48.3136L32.7834 43.4224L32.7406 43.3857Z",
    fill: "#FFF35A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6419 44.6758L30.9062 48.6193C30.9307 48.6193 30.9552 48.6193 30.9796 48.6193L34.6847 44.7125L34.6419 44.6758Z",
    fill: "#FFF35A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5499 44.59L34.3237 44.376L30.3252 48.5946C30.4658 48.6007 30.6003 48.6068 30.7409 48.613L34.5499 44.59Z",
    fill: "#BF5F00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5439 45.9619L34.2939 48.3402C34.3245 48.3341 34.3551 48.328 34.3795 48.3219L36.5806 45.9986L36.5439 45.9619Z",
    fill: "#FFF35A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.451 45.881L36.2248 45.667L33.5713 48.4672C33.7425 48.4427 33.9137 48.4183 34.0787 48.3877L36.451 45.881Z",
    fill: "#BF5F00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6335 45.881L38.4073 45.667L36.3896 47.7947C36.6098 47.7213 36.8299 47.6418 37.05 47.5562L38.6335 45.881Z",
    fill: "#BF5F00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7204 45.9619L37.3203 47.4415C37.357 47.4232 37.3998 47.4109 37.4365 47.3926L38.7571 45.9986L38.7204 45.9619Z",
    fill: "#FFF35A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9686 39.4221L26.9434 39.4487L27.0321 39.5328L27.0574 39.5062L26.9686 39.4221Z",
    fill: "#FFF35A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9482 39.4438L21.4814 45.2134L21.5702 45.2975L27.0369 39.5279L26.9482 39.4438Z",
    fill: "#FFF35A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3309 37.781L25.3057 37.8076L25.3944 37.8917L25.4197 37.8651L25.3309 37.781Z",
    fill: "#FFF35A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3066 37.8061L19.8398 43.5757L19.9286 43.6598L25.3953 37.8902L25.3066 37.8061Z",
    fill: "#FFF35A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6932 36.1394L23.668 36.166L23.7567 36.2501L23.782 36.2235L23.6932 36.1394Z",
    fill: "#FFF35A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3292 41.9799L23.7584 36.2511L23.6667 36.1655L18.2559 41.876C18.2803 41.9127 18.3048 41.9432 18.3292 41.9799Z",
    fill: "#FFF35A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0506 34.4968L22.0254 34.5234L22.1142 34.6075L22.1394 34.5809L22.0506 34.4968Z",
    fill: "#FFF35A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0758 39.9262L22.1137 34.6071L22.022 34.5215L17.0146 39.8101C17.033 39.8529 17.0574 39.8895 17.0758 39.9262Z",
    fill: "#FFF35A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.409 32.8606L20.3838 32.8872L20.4726 32.9713L20.4978 32.9447L20.409 32.8606Z",
    fill: "#FFF35A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1043 37.5847L20.4758 32.9748L20.3841 32.8892L16.0615 37.4502C16.0738 37.493 16.0921 37.5358 16.1043 37.5847Z",
    fill: "#FFF35A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7713 31.2219L18.7461 31.2485L18.8349 31.3326L18.8601 31.306L18.7713 31.2219Z",
    fill: "#FFF35A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4864 34.8626L18.8368 31.3288L18.7451 31.2432L15.4619 34.7098C15.468 34.7587 15.4741 34.8137 15.4864 34.8626Z",
    fill: "#FFF35A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1327 29.5793L17.1074 29.606L17.1962 29.6901L17.2214 29.6634L17.1327 29.5793Z",
    fill: "#FFF35A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3701 31.6179L17.1921 29.692L17.1004 29.6064L15.3823 31.4223C15.3762 31.4895 15.3762 31.5507 15.3701 31.6179Z",
    fill: "#FFF35A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7847 23.4605L20.7549 23.4912L20.8425 23.5765L20.8724 23.5458L20.7847 23.4605Z",
    fill: "#FFF35A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8232 28.7389L20.8428 23.5788L20.7572 23.4932L15.8905 28.5005C15.866 28.5739 15.8477 28.6595 15.8232 28.7389Z",
    fill: "#FFF35A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7877 21.3922L20.7578 21.4229L20.8455 21.5081L20.8753 21.4774L20.7877 21.3922Z",
    fill: "#FFF35A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.126 25.3319L20.8494 21.5045L20.7638 21.4189L17.34 24.9345C17.2605 25.069 17.1932 25.1974 17.126 25.3319Z",
    fill: "#FFF35A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.869 40.7063L28.8438 40.7329L28.9325 40.817L28.9577 40.7904L28.869 40.7063Z",
    fill: "#FFF35A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4584 46.5793C23.4645 46.5793 23.4645 46.5854 23.4706 46.5854L28.9365 40.82L28.8448 40.7344L23.3789 46.4998L23.4584 46.5793Z",
    fill: "#FFF35A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 41.9934L30.748 42.02L30.8368 42.1041L30.862 42.0775L30.7733 41.9934Z",
    fill: "#FFF35A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6352 47.5925L30.8382 42.1022L30.7465 42.0166L25.5068 47.5436C25.5496 47.562 25.5924 47.5803 25.6352 47.5925Z",
    fill: "#FFF35A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6717 43.279L32.6465 43.3057L32.7352 43.3898L32.7605 43.3631L32.6717 43.279Z",
    fill: "#FFF35A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0823 48.304L32.735 43.3883L32.6433 43.3027L27.9355 48.2673C27.9906 48.2856 28.0395 48.2978 28.0823 48.304Z",
    fill: "#FFF35A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.576 44.5666L34.5508 44.5933L34.6395 44.6774L34.6648 44.6507L34.576 44.5666Z",
    fill: "#FFF35A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9053 48.6209L34.6409 44.6774L34.5492 44.5918L30.7402 48.6148C30.7953 48.6148 30.8503 48.6209 30.9053 48.6209Z",
    fill: "#FFF35A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4764 45.8528L36.4512 45.8794L36.5399 45.9635L36.5652 45.9369L36.4764 45.8528Z",
    fill: "#FFF35A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2863 48.3379L36.5362 45.9596L36.4445 45.874L34.0723 48.3746C34.1517 48.3685 34.219 48.3502 34.2863 48.3379Z",
    fill: "#FFF35A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6571 45.8493L38.6318 45.876L38.7206 45.9601L38.7458 45.9335L38.6571 45.8493Z",
    fill: "#FFF35A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3191 47.4392L38.7192 45.9596L38.6275 45.874L37.0439 47.5431C37.1418 47.5126 37.2274 47.4759 37.3191 47.4392Z",
    fill: "#FFF35A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M32.716 47.4041C41.5257 47.4041 48.6673 40.2625 48.6673 31.4528C48.6673 22.6431 41.5257 15.5015 32.716 15.5015C23.9063 15.5015 16.7646 22.6431 16.7646 31.4528C16.7646 40.2625 23.9063 47.4041 32.716 47.4041Z",
    fill: "#FFBC00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7164 15.5015C28.296 15.5015 24.2913 17.3051 21.3994 20.2092C24.1874 17.8309 27.8007 16.3941 31.7504 16.3941C40.5606 16.3941 47.7017 23.5352 47.7017 32.3454C47.7017 36.7291 45.9348 40.7032 43.0673 43.5829C46.4911 40.6604 48.6616 36.3073 48.6616 31.4528C48.6677 22.6426 41.5266 15.5015 32.7164 15.5015Z",
    fill: "#FFF35A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6114 44.4322C39.7226 44.4322 45.4874 38.6674 45.4874 31.5562C45.4874 24.445 39.7226 18.6802 32.6114 18.6802C25.5001 18.6802 19.7354 24.445 19.7354 31.5562C19.7354 38.6674 25.5001 44.4322 32.6114 44.4322Z",
    fill: "#FFAA00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7159 18.9139C34.4094 18.9139 36.048 19.2441 37.5948 19.8983C39.0866 20.528 40.4317 21.4329 41.5811 22.5884C42.7305 23.7378 43.6354 25.0829 44.2712 26.5747C44.9254 28.1215 45.2556 29.7601 45.2556 31.4536C45.2556 33.1472 44.9254 34.7858 44.2712 36.3326C43.6415 37.8244 42.7366 39.1695 41.5811 40.3189C40.4317 41.4683 39.0866 42.3732 37.5948 43.009C36.048 43.6632 34.4094 43.9934 32.7159 43.9934C31.0223 43.9934 29.3837 43.6632 27.8369 43.009C26.3451 42.3793 25 41.4744 23.8506 40.3189C22.7012 39.1695 21.7963 37.8244 21.1605 36.3326C20.5063 34.7858 20.1761 33.1472 20.1761 31.4536C20.1761 29.7601 20.5063 28.1215 21.1605 26.5747C21.7902 25.0829 22.6951 23.7378 23.8506 22.5884C25 21.439 26.3451 20.5341 27.8369 19.8983C29.3837 19.2441 31.0223 18.9139 32.7159 18.9139ZM32.7159 18.5776C25.6053 18.5776 19.8398 24.3431 19.8398 31.4536C19.8398 38.5642 25.6053 44.3297 32.7159 44.3297C39.8264 44.3297 45.598 38.5642 45.598 31.4536C45.598 24.3431 39.8325 18.5776 32.7159 18.5776Z",
    fill: "#FF9100"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6114 18.8225C34.3294 18.8225 35.9985 19.1588 37.5698 19.8252C39.086 20.4672 40.4495 21.3843 41.6172 22.552C42.785 23.7198 43.7021 25.0832 44.3441 26.5995C45.0105 28.1708 45.3467 29.8338 45.3467 31.5579C45.3467 33.2759 45.0105 34.945 44.3441 36.5163C43.7021 38.0326 42.785 39.396 41.6172 40.5638C40.4495 41.7315 39.086 42.6486 37.5698 43.2906C35.9985 43.957 34.3355 44.2933 32.6114 44.2933C30.8933 44.2933 29.2242 43.957 27.6529 43.2906C26.1367 42.6486 24.7733 41.7315 23.6055 40.5638C22.4377 39.396 21.5206 38.0326 20.8787 36.5163C20.2122 34.945 19.876 33.282 19.876 31.5579C19.876 29.8399 20.2122 28.1708 20.8787 26.5995C21.5206 25.0832 22.4377 23.7198 23.6055 22.552C24.7733 21.3843 26.1367 20.4672 27.6529 19.8252C29.2242 19.1588 30.8933 18.8225 32.6114 18.8225ZM32.6114 18.6758C25.5008 18.6758 19.7354 24.4412 19.7354 31.5518C19.7354 38.6623 25.5008 44.4278 32.6114 44.4278C39.7219 44.4278 45.4935 38.6684 45.4935 31.5579C45.4935 24.4412 39.7219 18.6758 32.6114 18.6758Z",
    fill: "#E57E03"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9727 18.5332C39.9915 18.5332 45.6836 24.2987 45.6836 31.4092C45.6836 36.6489 42.596 41.1549 38.1634 43.1664",
    stroke: "#FFCB57",
    strokeWidth: 0.0361381,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2778 24.8442H27.1387V28.9834H31.2778V24.8442Z",
    fill: "#E57E03"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2778 33.1289H27.1387V37.2681H31.2778V33.1289Z",
    fill: "#E57E03"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4243 28.9897H31.2852V33.1289H35.4243V28.9897Z",
    fill: "#E57E03"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M39.562 33.1289H35.4229V37.2681H39.562V33.1289Z",
    fill: "#E57E03"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2976 25.7552L27.1387 24.8443L27.5544 24.5508L28.9851 27.4671L27.2976 25.7552Z",
    fill: "#E57E03"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2854 28.9891L31.1387 28.3838L31.695 28.6895L31.909 32.1194L35.8342 32.8286L36.3661 34.1554L35.6202 33.9047L35.4246 33.1282H34.8315L31.5116 32.7186L31.2854 28.9891Z",
    fill: "#E57E03"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5197 37.2683H31.2839L31.6936 36.9749L28.1903 34.3275L27.5544 32.8296L27.1387 33.1292L27.3221 36.7548L30.5197 37.2683Z",
    fill: "#E57E03"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9786 36.975L39.5628 37.2684H38.1505L36.3652 34.9023L39.9786 36.975Z",
    fill: "#E57E03"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6948 24.5542H27.5557V28.6934H31.6948V24.5542Z",
    fill: "#FFD400"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6948 32.8306H27.5557V36.9697H31.6948V32.8306Z",
    fill: "#FFD400"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9797 28.6914H31.6953V32.8306H39.9797V28.6914Z",
    fill: "#FFD400"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9731 32.8306H35.834V36.9697H39.9731V32.8306Z",
    fill: "#FFD400"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5236 24.7041V28.6904H31.6948V24.5513H27.5557V24.7041H31.5236Z",
    fill: "#FFF35A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8066 28.8433V32.8296H39.9778V28.6904H31.6934V28.8433H39.8066Z",
    fill: "#FFF35A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8079 32.9824V36.9749H39.9791V32.8296H39.8018V32.9824H39.8079Z",
    fill: "#FFF35A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5225 34.9212V36.9754H31.6937V34.7744L31.5225 34.9212Z",
    fill: "#FFF35A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#6C53E8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9993 39.6665C43.1099 39.6665 43.2158 39.7104 43.294 39.7885C43.3721 39.8667 43.416 39.9727 43.416 40.0832V42.5832H45.916C46.0265 42.5832 46.1325 42.6271 46.2106 42.7052C46.2888 42.7833 46.3327 42.8893 46.3327 42.9998C46.3327 43.1103 46.2888 43.2163 46.2106 43.2945C46.1325 43.3726 46.0265 43.4165 45.916 43.4165H43.416V45.9165C43.416 46.027 43.3721 46.133 43.294 46.2111C43.2158 46.2893 43.1099 46.3332 42.9993 46.3332C42.8888 46.3332 42.7829 46.2893 42.7047 46.2111C42.6266 46.133 42.5827 46.027 42.5827 45.9165V43.4165H40.0827C39.9722 43.4165 39.8662 43.3726 39.7881 43.2945C39.7099 43.2163 39.666 43.1103 39.666 42.9998C39.666 42.8893 39.7099 42.7833 39.7881 42.7052C39.8662 42.6271 39.9722 42.5832 40.0827 42.5832H42.5827V40.0832C42.5827 39.9727 42.6266 39.8667 42.7047 39.7885C42.7829 39.7104 42.8888 39.6665 42.9993 39.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpHpr);
export default __webpack_public_path__ + "static/media/top-up-hpr.bdfa525f2925befef8a9fa361860a1a5.svg";
export { ForwardRef as ReactComponent };